import {
  Component, OnInit, OnChanges, Input, ViewChildren, QueryList, SimpleChanges, Output,
  EventEmitter
} from '@angular/core';
import {MatMenuTrigger} from '@angular/material';
import {UtilsService} from '../../core/utils/utils.service';

@Component({
  selector: 'app-sidenav2',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})

export class Sidenav2Component implements OnInit, OnChanges {
  menuOpened = false;
  menuIcons = '../../assets/images/menu-icons/';
  styleOpenedSidenav = {width: '40px'};
  menuTimer;
  @Input() modulos: any[];
  @Input() videoUrl;
  @Input() showConfig;
  @Input() onBackdrop = false;
  @Output() isMenuOpened: EventEmitter<any> = new EventEmitter<any>();

  @ViewChildren('menuTrigger') menuTrigger: QueryList<MatMenuTrigger>;

  usuarioPapel;
  modulosFiltered = [];

  constructor(private _utils: UtilsService) {
  }

  filterModulos(modulos, usuarioPapel) {
    return modulos.filter((modulo) => {
      if (modulo.showMenu && modulo['papeis'] && modulo['papeis'].indexOf(usuarioPapel) > -1) {
        if (modulo.children) {
          return modulo.children = this.filterModulos(modulo.children, usuarioPapel);
        } else {
          return modulo;
        }
      }
    });
  }

  mouseOnSidenav() {
    const component = this;
    this.menuOpened = true;
    this.isMenuOpened.emit(true);
    this.menuTimer = setTimeout(function () {
      component.styleOpenedSidenav = {
        width: '248px'
      };
    }, 0);
  }

  mouseLeaveSidenav() {
    this.menuOpened = false;
    this.isMenuOpened.emit(false);
    clearTimeout(this.menuTimer);
    this.styleOpenedSidenav = {
      width: '40px'
    };
  }

  openMenu(i) {
    for (const menuTrigger of this.menuTrigger['_results']) {
      menuTrigger.closeMenu();
    }
    this.menuTrigger['_results'][i].openMenu();
  }


  closeMenus() {
    for (const menuTrigger of this.menuTrigger['_results']) {
      menuTrigger.closeMenu();
      menuTrigger._viewContainerRef.element.nativeElement.blur();
    }
  }

  ngOnInit() {
  }

  createRoute(modulos, parent?) {
    return modulos.map((item) => {
      if (!parent && !item.children) {
        item.route = '/' + item.nome;
      } else if (!parent && item.children) {
        item.route = item.nome;
      } else {
        item.route = parent.route + '/' + item.nome;
      }

      if (item['children']) {
        this.createRoute(item['children'], item);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.usuarioPapel = this._utils.getUsuarioPapel();
    if (changes.modulos && changes.modulos.currentValue) {
      if (this.usuarioPapel !== 'super') {
        this.createRoute(changes.modulos.currentValue);
        this.modulosFiltered = this.filterModulos(this.modulos, this.usuarioPapel);
      } else {
        this.createRoute(changes.modulos.currentValue);
        this.modulosFiltered = this.modulos.filter(modulo => modulo.showMenu);
      }
    }
    if (changes.onBackdrop && changes.onBackdrop.currentValue) {
      this.closeMenus();
      this.mouseLeaveSidenav();
    }
  }
}
